import { useState } from "react";
import { AwardForm } from "../form/award";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Pencil1Icon } from "@radix-ui/react-icons";
type AwardFormSubmit = {
  award: string;
};

export const Award = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState({});

  const handleEdit = (award: any, index: any) => {
    setSelected({ awardName: award, index });
    setIsOpen(true)
  }

  return (
    <>
      <div className="col">
        {props?.awards?.map((award: any, index: any) => {
          return (
            <>
              <div className="row bg-white">
                <div className="col-md-11 mt-1">
                  <p key={award}>{award}</p>
                </div>
                {props.isEditAwards &&
                  (<div className="flex flex-row justify-end">
                    <Pencil1Icon
                      height={undefined}
                      width={undefined}
                      className="h-6 sm:h-7 cursor-pointer "
                      onClick={() => handleEdit(award, index)} />

                  </div>)}
              </div>
              <hr />
            </>
          );
        })}
      </div>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>

        <DialogContent>

          <AwardForm id={props.id} onUpdate={props.onUpdate} awardDetails={selected} />
        </DialogContent>


      </Dialog>
    </>
  );
};
